<template>
  <b-form-textarea
    v-on="$listeners"
    :id="id"
    :ref="refInput"
    type="text"
    :disabled="disabled"
    :autofocus="autofocus"
    :placeholder="placeholder"
    v-model="_dataModel"
    @input="onInput"
    :class="[
      state ? 'border-danger bg-danger-outline' : '',
      classCustom ? classCustom : '',
      'overflow-auto'
    ]"
    :title="title"
    @keydown="onkeydown"
    @paste="onPaste"
    @blur="onBlur"
    rows="3"
  />
</template>

<script>
export default {
  model: {
    prop: 'dataModel',
    event: 'change'
  },
  props: {
    id: {
      type: String,
      default: ''
    },
    maxlength: {
      type: Number
    },
    autofocus: {
      type: Boolean,
      default: false
    },
    dataModel: {
      type: Number | String,
      default: null
    },
    state: {
      type: Boolean,
      default: null
    },
    placeholder: {
      type: Number | String,
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    },
    classCustom: {
      type: Array | String | Object,
      default: null
    },
    refInput: {
      type: String,
      default: ''
    }
  },
  computed: {
    _dataModel: {
      get() {
        return this.dataModel
      },
      set(value) {
        this.$emit('change', value)
      }
    }
  },
  methods: {
    onInput(value) {
      const input = document.getElementById(this.id)
      if (value.length > this.maxlength) {
        input.setCustomValidity(`${this.maxlength}文字以下にしてください。`)
        setTimeout(() => {
          this._dataModel = value.substring(0, this.maxlength)
        }, 10)
      } else {
        input.setCustomValidity('')
      }
      input.reportValidity()
      this.$emit('onInput', value.substring(0, this.maxlength))
    },
    onkeydown(event) {
      this.$emit('onKeydown', event)
    },
    onPaste(event) {
      this.$emit('onPaste', event)
    },
    onBlur() {
      this.$emit('onBlur')
    }
  }

}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/custom-components/InputTextAreaComponent.vue